<template>
    <div class="container">
		<div class="form__wrapper form__wrapper--no-border">
			<div class="form__body">
				<form @submit.prevent="createPost">
					<div class="form-row">
						<div class="col-md-12">
							<div class="form-group">
								<label for="title">Provide a discussion title</label>
								<input
									id="title"
									v-model="itemData.title"
									@keydown="clearErrors($event.target.name)"
									:class="[{ 'is-invalid': errors.title}]"
									class="form-control"
									placeholder="Enter a title here"
									type="text">
								<div class="invalid-feedback">
									{{ errors.title }}
								</div>
							</div>
						</div>
					</div>
					<div class="form-row">
						<div class="col-md-12">
							<div class="form-group">
								<label for="forum-body">Ask your question</label>
								<textarea
									id="forum-body"
									v-model="itemData.description"
									@keydown="clearErrors($event.target.name)"
									title=""
									:class="[{ 'is-invalid': errors.description}]"
									class="input input--lg input--light"
									cols="30"
									rows="4"
									placeholder="What do you need help with? Please be specific, so that your peers are better able to assist you.">
								</textarea>
								<div class="invalid-feedback">
									{{ errors.description }}
								</div>
							</div>
						</div>
					</div>

					<div class="btn__group btn__group--form">
						<button
								@click="$router.go(-1)"
							class="btn__grey">Cancel</button>
						<button
							@click.prevent="createPost"
							:v-bind="{'disabled': loading}"
							class="btn__primary btn__primary--lg">Publish discussion</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import { createCourseForum } from '../../utils/api/course';
import form from '../../mixins/form';
import courseForum from '../../utils/validations/course';
import { success, fail } from '../../utils/toast';

export default {
	name: 'CreateCourseDiscussion',
	mixins: [form],
	data() {
		return {
			itemData: {
				title: '',
				description: ''
			},
			errors: {}
		};
	},
	methods: {
		createPost() {
			this.validate(this.itemData, courseForum.create);
			if (Object.keys(this.issues).length > 0) {
				this.errors = this.issues;
				return false;
			}

			createCourseForum(
              this.$route.params.onlineClassId || this.$route.params.id,
              {
                ...this.itemData,
                online_class_id: this.$route.params.onlineClassId || this.$route.params.id,
                user_id: this.$session.get('id')
              }
            )
				.then((response) => {
					if (response.status === 201) {
						success({
							title: 'Success! Added new course discussion.'
						});
						this.$router.go(-1);
					}
				}).catch((error) => {
					fail({
						title: 'Oops! Something went wrong',
						text: error.data
					});
				});
			return true;
		}
	}
};
</script>

<style scoped>
.btn__grey {
	margin-right: 15px;
	margin-left: 0;
	text-transform: uppercase;
}
.btn__group {
	position: relative;
}
</style>

